<template>
  <div>
    <v-row class="hph-filters-row" align="end">
      <!-- <v-col cols="12" md="6" lg="4">
        <v-autocomplete v-model="filtros.moldes" :items="moldes" item-text="codigo" item-value="idMolde" label="Molde"
          multiple chips clearable :loading="loadingMoldes" :disabled="loadingReporte" hide-details>
          <template v-slot:selection="{ index }">
            <v-chip v-if="index === 0" small>
              {{ filtros.moldes.length }} moldes
            </v-chip>
          </template>
</v-autocomplete>
</v-col> -->

      <v-col cols="12" md="6" lg="4">
        <v-autocomplete v-model="filtros.areas" :items="areas" item-text="nombre" item-value="idArea" label="Área"
          multiple chips clearable :loading="loadingAreas" :disabled="loadingReporte" hide-details />
      </v-col>

      <v-col cols="12" md="6" lg="3">
        <datePicker v-model="filtros.inicioDesde" format="YYYY-MM-DD" label="Inicio desde (Obligatorio)"
          :disabled="loadingReporte" maxToday />
      </v-col>

      <v-col cols="12" md="6" lg="3">
        <datePicker v-model="filtros.inicioHasta" format="YYYY-MM-DD" label="Inicio hasta (Obligatorio)"
          :disabled="loadingReporte" maxToday />
      </v-col>

      <v-col cols="12" md="12" lg="2" class="d-flex justify-end">
        <v-btn color="primary" :loading="loadingReporte" :disabled="!filtrosValidos || loadingReporte"
          @click="consultar">
          Consultar
        </v-btn>
      </v-col>
    </v-row>

    <LoaderData :loading="loadingReporte" :response="resumenPorMolde" :error="errorReporte">
      <section class="molde-chart-card mt-4">
        <div class="molde-chart-head">
          <div class="molde-chart-title">
            {{ detailViewMode === "cantidad" ? "Paros totales por molde (eventos)" : "Paro total por molde (minutos)" }}
          </div>
          <div class="molde-detail-toggle">
            <button type="button" class="molde-toggle-btn"
              :class="{ 'molde-toggle-btn--active': detailViewMode === 'tiempo' }" @click="detailViewMode = 'tiempo'">
              Tiempo
            </button>
            <button type="button" class="molde-toggle-btn"
              :class="{ 'molde-toggle-btn--active': detailViewMode === 'cantidad' }"
              @click="detailViewMode = 'cantidad'">
              Cantidad
            </button>
          </div>
        </div>

        <div v-if="chartSeries[0].data.length" class="molde-chart-wrap">
          <apexchart type="bar" :height="chartHeight" :options="chartOptions" :series="chartSeries" />
        </div>

        <div v-else class="molde-empty-state">
          Sin datos para mostrar.
        </div>
      </section>
    </LoaderData>

    <v-dialog v-model="dialogMolde" max-width="980">
      <v-card>
        <v-card-title class="text-h6">
          Detalle de molde {{ selectedMolde ? selectedMolde.codigoMolde : "" }}
        </v-card-title>
        <v-card-text>
          <div v-if="detailChartSeries.length" class="molde-chart-wrap">
            <apexchart type="bar" :height="detailChartHeight" :options="detailChartOptions"
              :series="detailChartSeries" />
          </div>
          <div v-else class="molde-empty-state">
            Sin detalle de paros para este molde.
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text color="primary" @click="dialogMolde = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import LoaderData from "../../LoaderData.vue";

export default {
  components: {
    LoaderData,
  },
  props: {
    active: { type: Boolean, default: true },
  },
  data() {
    return {
      moldes: [],
      areas: [],
      resumenPorMolde: [],

      loadingMoldes: false,
      loadingAreas: false,
      loadingReporte: false,
      errorReporte: false,
      consultado: false,

      filtros: {
        moldes: [],
        areas: [],
        inicioDesde: null,
        inicioHasta: null,
      },

      detailViewMode: "tiempo",
      dialogMolde: false,
      selectedMolde: null,
    };
  },
  computed: {
    filtrosValidos() {
      if (!this.filtros.inicioDesde || !this.filtros.inicioHasta) return false;
      return this.filtros.inicioDesde <= this.filtros.inicioHasta;
    },
    chartHeight() {
      const total = this.chartSeries[0].data.length;
      return Math.max(340, total * 42 + 80);
    },
    chartSeries() {
      return [
        {
          name: this.detailViewMode === "cantidad" ? "Eventos" : "Minutos paro",
          data: this.sortedResumenPorMolde.map((item) =>
            this.detailViewMode === "cantidad"
              ? this.toNumber(item.totalEventosAgrupados)
              : this.toNumber(item.totalMinutosParo)
          ),
        },
      ];
    },
    sortedResumenPorMolde() {
      const sorted = [...this.resumenPorMolde];
      sorted.sort((a, b) => {
        const aValue =
          this.detailViewMode === "cantidad"
            ? this.toNumber(a.totalEventosAgrupados)
            : this.toNumber(a.totalMinutosParo);
        const bValue =
          this.detailViewMode === "cantidad"
            ? this.toNumber(b.totalEventosAgrupados)
            : this.toNumber(b.totalMinutosParo);
        return bValue - aValue;
      });
      return sorted;
    },
    selectedMoldeMachines() {
      if (!this.selectedMolde || !this.selectedMolde.raw) return [];
      const moldesMaquina = Array.isArray(this.selectedMolde.raw.moldesMaquina)
        ? this.selectedMolde.raw.moldesMaquina
        : [];
      if (!moldesMaquina.length) return [];

      const byMachine = new Map();
      moldesMaquina.forEach((mm) => {
        const machineKey = `${mm.idMaquina || ""}-${mm.nombreMaquina || ""}`;
        const paros = Array.isArray(mm.parosPorTipoSubtipo) ? mm.parosPorTipoSubtipo : [];
        if (!byMachine.has(machineKey)) {
          byMachine.set(machineKey, {
            idMaquina: mm.idMaquina,
            nombreMaquina: mm.nombreMaquina || "-",
            parosPorTipoSubtipo: [],
          });
        }
        const machineRow = byMachine.get(machineKey);
        machineRow.parosPorTipoSubtipo = machineRow.parosPorTipoSubtipo.concat(paros);
      });

      return Array.from(byMachine.values()).sort((a, b) => {
        const getMachineValue = (machine) => {
          const paros = Array.isArray(machine.parosPorTipoSubtipo) ? machine.parosPorTipoSubtipo : [];
          return paros.reduce((acc, paro) => {
            if (this.detailViewMode === "cantidad") {
              return acc + this.getEventosParoValue(paro);
            }
            return acc + this.toNumber(paro.totalMinutosParo);
          }, 0);
        };
        return getMachineValue(b) - getMachineValue(a);
      });
    },
    detailMachineLabels() {
      return this.selectedMoldeMachines.map(
        (mm) => mm.nombreMaquina || `Máquina ${mm.idMaquina || "-"}`
      );
    },
    detailChartSeries() {
      const moldesMaquina = this.selectedMoldeMachines;
      if (!moldesMaquina.length) return [];

      const causes = [];
      const causeSet = new Set();

      moldesMaquina.forEach((mm) => {
        const paros = Array.isArray(mm.parosPorTipoSubtipo) ? mm.parosPorTipoSubtipo : [];
        paros.forEach((paro) => {
          const cause =
            paro.nombreSubParoTipo ||
            paro.nombreParoTipo ||
            `Causa ${paro.idSubParoTipo || paro.idParoTipo || "-"}`;
          if (!causeSet.has(cause)) {
            causeSet.add(cause);
            causes.push(cause);
          }
        });
      });

      return causes.map((cause) => {
        const data = moldesMaquina.map((mm) => {
          const paros = Array.isArray(mm.parosPorTipoSubtipo) ? mm.parosPorTipoSubtipo : [];
          return paros.reduce((acc, paro) => {
            const currentCause =
              paro.nombreSubParoTipo ||
              paro.nombreParoTipo ||
              `Causa ${paro.idSubParoTipo || paro.idParoTipo || "-"}`;
            if (currentCause !== cause) return acc;
            const value =
              this.detailViewMode === "cantidad"
                ? this.getEventosParoValue(paro)
                : this.toNumber(paro.totalMinutosParo);
            return acc + value;
          }, 0);
        });

        return {
          name: cause,
          data,
        };
      });
    },
    detailChartHeight() {
      const total = this.detailMachineLabels.length;
      return Math.max(320, total * 56 + 70);
    },
    chartOptions() {
      return {
        chart: {
          toolbar: { show: false },
          events: {
            dataPointSelection: (event, chartContext, config) => {
              this.onMoldeBarClick(config.dataPointIndex);
            },
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            borderRadius: 5,
            distributed: false,
          },
        },
        dataLabels: {
          enabled: true,
          formatter: (value) => this.formatNumber(value),
        },
        xaxis: {
          min: 0,
          categories: this.sortedResumenPorMolde.map((item) => item.codigoMolde),
          title: {
            text: this.detailViewMode === "cantidad" ? "Cantidad de paros" : "Minutos de paro",
          },
          labels: {
            formatter: (value) => this.formatNumber(value),
          },
        },
        yaxis: {
          title: {
            text: "Molde",
          },
        },
        tooltip: {
          y: {
            formatter: (value) => {
              if (this.detailViewMode === "cantidad") {
                return `${this.formatNumber(value)} eventos`;
              }
              return `${this.formatNumber(value)} min`;
            },
          },
        },
        colors: ["#2f6db0"],
        grid: {
          borderColor: "#e4ebf5",
        },
      };
    },
    detailChartOptions() {
      return {
        chart: {
          stacked: true,
          toolbar: { show: false },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            borderRadius: 4,
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          min: 0,
          categories: this.detailMachineLabels,
          title: {
            text: this.detailViewMode === "cantidad" ? "Cantidad de paros" : "Minutos de paro",
          },
          labels: {
            formatter: (value) => this.formatNumber(value),
          },
        },
        yaxis: {
          title: {
            text: "",
          },
        },
        legend: {
          position: "bottom",
          showForSingleSeries: true,
        },
        tooltip: {
          y: {
            formatter: (value) => {
              if (this.detailViewMode === "cantidad") {
                return `${this.formatNumber(value)} eventos`;
              }
              return `${this.formatNumber(value)} min`;
            },
          },
        },
        grid: {
          borderColor: "#e4ebf5",
        },
      };
    },
  },
  watch: {
    active(newVal) {
      if (newVal && !this.consultado && this.filtrosValidos) {
        this.consultar();
      }
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getMoldes();
      this.getAreas();
      // this.setDefaultDates();
    },
    setDefaultDates() {
      const today = new Date();
      const sevenDaysAgo = new Date(today);
      sevenDaysAgo.setDate(today.getDate() - 7);

      this.filtros.inicioHasta = this.toDateInput(today);
      this.filtros.inicioDesde = this.toDateInput(sevenDaysAgo);
    },
    toDateInput(date) {
      const d = new Date(date);
      const month = `${d.getMonth() + 1}`.padStart(2, "0");
      const day = `${d.getDate()}`.padStart(2, "0");
      return `${d.getFullYear()}-${month}-${day}`;
    },
    toNumber(value) {
      const n = Number(value);
      return Number.isFinite(n) ? n : 0;
    },
    getEventosParoValue(paro) {
      return this.toNumber(paro && (paro.totalEventosAgrupados ?? paro.totalEventos));
    },
    formatNumber(value) {
      return this.toNumber(value).toLocaleString("en-US");
    },
    getMoldes() {
      this.loadingMoldes = true;
      axios
        .get("/Moldes")
        .then((response) => {
          this.moldes = Array.isArray(response.data) ? response.data : [];
        })
        .catch((error) => console.log(error))
        .finally(() => {
          this.loadingMoldes = false;
        });
    },
    getAreas() {
      this.loadingAreas = true;
      axios
        .get("/Areas")
        .then((response) => {
          const data = Array.isArray(response.data) ? response.data : [];
          this.areas = data.filter((a) => a.idArea > 1);
        })
        .catch((error) => console.log(error))
        .finally(() => {
          this.loadingAreas = false;
        });
    },
    buildQuery() {
      const params = new URLSearchParams();
      this.filtros.moldes.forEach((id) => params.append("idMolde", id));
      this.filtros.areas.forEach((id) => params.append("idArea", id));
      params.append("inicioDesde", this.filtros.inicioDesde);
      params.append("inicioHasta", this.filtros.inicioHasta);
      return params.toString();
    },
    mapReporte(payload) {
      if (!Array.isArray(payload)) return [];

      const mapped = payload.map((item) => {
        const moldesMaquinaRaw = Array.isArray(item.moldesMaquina) ? item.moldesMaquina : [];
        const byMachine = new Map();

        moldesMaquinaRaw.forEach((mm) => {
          const machineKey = `${mm.idMaquina || ""}-${mm.nombreMaquina || ""}`;
          const paros = Array.isArray(mm.parosPorTipoSubtipo) ? mm.parosPorTipoSubtipo : [];
          if (!byMachine.has(machineKey)) {
            byMachine.set(machineKey, {
              idMaquina: mm.idMaquina,
              nombreMaquina: mm.nombreMaquina || "-",
              parosPorTipoSubtipo: [],
            });
          }
          const machineRow = byMachine.get(machineKey);
          machineRow.parosPorTipoSubtipo = machineRow.parosPorTipoSubtipo.concat(paros);
        });

        const moldesMaquina = Array.from(byMachine.values());

        const totalMinutosParo = moldesMaquina.reduce((acumMaquina, maquina) => {
          const paros = Array.isArray(maquina.parosPorTipoSubtipo) ? maquina.parosPorTipoSubtipo : [];
          return (
            acumMaquina +
            paros.reduce((acumParo, paro) => {
              return acumParo + this.toNumber(paro.totalMinutosParo);
            }, 0)
          );
        }, 0);
        const totalEventosAgrupados = moldesMaquina.reduce((acumMaquina, maquina) => {
          const paros = Array.isArray(maquina.parosPorTipoSubtipo) ? maquina.parosPorTipoSubtipo : [];
          return (
            acumMaquina +
            paros.reduce((acumParo, paro) => {
              return acumParo + this.getEventosParoValue(paro);
            }, 0)
          );
        }, 0);

        return {
          codigoMolde: item.codigoMolde || "-",
          totalMinutosParo,
          totalEventosAgrupados,
          raw: {
            ...item,
            moldesMaquina,
          },
        };
      });

      return mapped.sort((a, b) => b.totalMinutosParo - a.totalMinutosParo);
    },
    onMoldeBarClick(index) {
      if (index < 0 || index >= this.sortedResumenPorMolde.length) return;
      this.selectedMolde = this.sortedResumenPorMolde[index];
      this.dialogMolde = true;
    },
    consultar() {
      if (!this.filtrosValidos) return;

      this.loadingReporte = true;
      this.errorReporte = false;

      axios
        .get(`/ReportesMoldes/ValidacionMoldesMultimaquinaParos?${this.buildQuery()}`)
        .then((response) => {
          this.consultado = true;
          this.resumenPorMolde = this.mapReporte(response.data);
        })
        .catch((error) => {
          console.log(error);
          this.errorReporte = true;
          this.resumenPorMolde = [];
        })
        .finally(() => {
          this.loadingReporte = false;
        });
    },
  },
};
</script>

<style scoped>
.molde-chart-card {
  background: linear-gradient(180deg, #ffffff 0%, #f7f9fc 100%);
  border: 1px solid #d8e2ef;
  border-radius: 14px;
  box-shadow: 0 8px 18px rgba(24, 43, 70, 0.09);
  padding: 14px;
}

.molde-chart-title {
  color: #1f2f46;
  font-size: 1.1rem;
  font-weight: 700;
  margin-bottom: 12px;
}

.molde-chart-head {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 8px 12px;
  justify-content: space-between;
}

.molde-chart-wrap {
  background: #ffffff;
  border: 1px solid #e3ebf5;
  border-radius: 10px;
  padding: 10px;
}

.molde-detail-toggle {
  display: inline-flex;
  gap: 8px;
  margin-bottom: 12px;
}

.molde-toggle-btn {
  background: #e7edf6;
  border: 1px solid #c6d4e8;
  border-radius: 999px;
  color: #3a4f6b;
  cursor: pointer;
  font-size: 0.85rem;
  font-weight: 700;
  padding: 4px 12px;
  transition: all 0.2s ease;
}

.molde-toggle-btn--active {
  background: #2f6db0;
  border-color: #255a94;
  color: #ffffff;
}

.molde-empty-state {
  color: #6d7f97;
  font-size: 0.92rem;
  padding: 8px 4px;
}
</style>
